import {Handle, Position} from "reactflow";
import journeyStmStore from "../common/service/journey-stm-store";
import {connect} from "react-redux";
import React, {useEffect, useState} from "react";

const getNodeData = id => {
    const storedSettings = journeyStmStore.get(id);
    if (storedSettings) {
        return storedSettings.stateConfig;
    } else {
        return null;
    }
}

const ChildNode = (props) => {
    return React.Children.map(props.children, child => {
        // checking isValidElement is the safe way and avoids a typescript error too
        const childProps = {
            id: props.id,
            name: props.name,
            onChangeData: props.onChangeData,
            savedSettings: props.savedSettings,
            metadata: props.metadata
        };
        if (React.isValidElement(child)) {
            return React.cloneElement(child, childProps);
        }
        return child;
    });
}

function NodeComponent(props) {
    const { data, className, nodeTypeIcon } = props;
    const { id, name, metadata, highlight } = data;

    const [isCurrentState, setIsCurrentState] = useState(false);

    const onChangeData = data => {
        journeyStmStore.add(id, data)
    }

    useEffect( () => {
        if (metadata && metadata.runningState) {
            setIsCurrentState(id === metadata.runningState)
        }
    }, [metadata]);

    // Define styles based on state
    let nodeStyle = {};
    let ringStyle = {};
    
    if (highlight) {
        // Highlight style (yellow)
        nodeStyle = {
            backgroundColor: 'rgb(var(--bg-yellow-100))',
            borderColor: '#facc15', // yellow-400
        };
        ringStyle = {
            boxShadow: '0 0 0 4px #facc15', // yellow-400 ring
        };
    } else if (isCurrentState) {
        // Current state style (blue/red)
        nodeStyle = {
            backgroundColor: 'rgb(var(--bg-indigo-50))',
            borderColor: 'rgb(var(--border-red-100))',
        };
        ringStyle = {
            boxShadow: '0 0 0 4px #60a5fa', // blue-400 ring
        };
    } else {
        // Default style (blue)
        nodeStyle = {
            backgroundColor: 'rgb(var(--bg-indigo-50))',
            borderColor: 'rgb(var(--border-blue-300))',
        };
    }

    // Base className without dynamic color classes
    const baseClassName = "pt-2 pb-4 px-4 w-72 flex flex-col gap-1 border rounded-md shadow-md";
    const nodeClassName = className || baseClassName;

    let stateName = name || 'New State';
    const nodeData = getNodeData(id)
    if (nodeData && nodeData.name) {
        stateName = nodeData.name;
    }

    return (
        <div className="">
            <Handle
                id="in"
                type="target"
                position={Position.Left}
                isConnectable={true}
            >
                {/*<div className="absolute right-0">*/}
                {/*    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-800" viewBox="0 0 20 20" fill="currentColor">*/}
                {/*        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z" clipRule="evenodd" />*/}
                {/*    </svg>*/}
                {/*</div>*/}
            </Handle>
            <div 
                className={nodeClassName}
                style={{...nodeStyle, ...ringStyle}}
            >

                <div className="">
                    <div className="p-2 rounded">
                        <p className="text-lg font-medium">{props.title}</p>
                    </div>
                </div>

                <p className='hidden'>this: {id}</p>
                <p className='hidden'>runningState: {metadata.runningState}</p>


                {/*<div className="py-1 px-2 pb-4">*/}
                {/*    <ChildNode*/}
                {/*                id={id}*/}
                {/*                name={name}*/}
                {/*                metadata={metadata}*/}
                {/*               onChangeData={onChangeData}*/}
                {/*               savedSettings={getNodeData(id)}*/}
                {/*    >*/}
                {/*        {props.children}*/}
                {/*    </ChildNode>*/}
                {/*</div>*/}
                <div className="">
                    <div className="p-2 rounded-md bg-white border-2 border-blue-200">
                        <p className="text-lg">{stateName}</p>
                    </div>
                </div>

            </div>
            <Handle
                id="out"
                type="source"
                position={Position.Right}
                isConnectable={true}
            >
                {/*<div className="">*/}
                {/*    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-800" viewBox="0 0 20 20" fill="currentColor">*/}
                {/*        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z" clipRule="evenodd" />*/}
                {/*    </svg>*/}
                {/*</div>*/}
            </Handle>
        </div>
    );
}

const mapsStateToProps = (state, ownProps) => {
    return {
    };
}

const mapDispatchToProps = dispatch => {
    return {
    };
}

export default connect(mapsStateToProps, mapDispatchToProps)(NodeComponent)
